import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Shop() {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/');
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <p className="text-white">Redirecting...</p>
    </div>
  );
}
